import React from 'react';

import { TableRowData } from '../../../../interfaces/tableRowData.types';

import { TableRow, TableCell, Container } from './table.styled';
import { TableData } from './table.types';

export const Table: React.FC<TableData> = (data: TableData) => {
  const { rowData } = data;

  const renderRows = () => rowData.map((row: TableRowData) => (
    <TableRow key={row.label}>
      <TableCell>
        {row.label}
      </TableCell>
      <TableCell>
        {row.value}
      </TableCell>
    </TableRow>
  ));

  return (
    <Container className='table-section'>
      {renderRows()}
    </Container>
  );
}
